import React, { useState, useMemo, useEffect } from 'react';
import { ConfigProvider, Space, Tag } from 'antd';
import { CustomLoader } from '@components/UI/CustomLoader/Index.jsx';
import { StyledTable } from '@styles/datatables/datatable-antd.js';
import ptBR from 'antd/es/locale/pt_BR';
import { DeleteUsuario, GetAllUsuarios } from '@services/Usuario/Index';
import { EditOptionComp } from '@components/UI/EditOption/Index';
import { DeleteOptionComp } from '@components/UI/DeleteOption/Index';
import TextBlock from '@components/UI/TextBlock/Index.';
import PerfilHistoricoComp from '@components/Solicitacao/Shared/Historico/PerfilHistorico/Index';

const GridUsuarios = ({ state, setData, filters, onDelete, openModal, setSelectedRow }) => {
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const apiFilters = useMemo(() => ({
    numeroSolicitacao: filters.numeroSolicitacao || null,
    nomeUnidadeGerencia: filters.nomeUnidadeGerencia || null,
    nome: filters.nome || null,
    perfil: filters.perfil || null
  }), [filters]);

  // Buscar dados apenas se ao menos um filtro for preenchido
  const fetchData = async (currentPage, currentRowsPerPage, apiFilters = {}) => {
    setLoading(true);
    try {
      const response = await GetAllUsuarios(currentPage, currentRowsPerPage, apiFilters);
      setData(response.items, response.totalItems);
    } catch (error) {
      console.error('Erro ao buscar dados dos usuarios:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(page, rowsPerPage, apiFilters);
  }, [page, rowsPerPage, apiFilters]);

  const columns = [
    {
      title: 'NOME',
      dataIndex: 'nome',
      key: 'nome',
      sorter: (a, b) => a.nome.localeCompare(b.nome),
      render: (text) => <TextBlock>{text}</TextBlock>,
      width: '30%',
    },
    {
      title: 'E-MAIL',
      dataIndex: 'email',
      key: 'email',
      sorter: (a, b) => a.email.localeCompare(b.email),
      render: (text) => <TextBlock>{text}</TextBlock>,
      width: '30%',
    },
    {
      title: 'PERFIL',
      dataIndex: 'perfil',
      key: 'perfil',
      sorter: (a, b) => a.perfil.localeCompare(b.perfil),
      render: (text, record) => (
        <PerfilHistoricoComp perfil={record.perfil} />
      ),
      width: '15%',
    },
    {
      title: 'STATUS',
      dataIndex: 'flgAtivo',
      key: 'flgAtivo',
      width: '15%',
      sorter: (a, b) => a.flgAtivo.localeCompare(b.flgAtivo),
      render: (flgAtivo) => (
        <Tag color={(flgAtivo) === true ? 'green' : 'red'}>
          {(flgAtivo) === true ? 'ATIVO' : 'INATIVO'}
        </Tag>
      ),
    },
    {
      title: 'AÇÕES',
      key: 'actions',
      render: (text, row) => (
        <Space size="middle">
          <EditOptionComp
            row={row}
            setSelectedRow={setSelectedRow}
            openModal={openModal}
          />
          <DeleteOptionComp
            row={row}
            deleteFunction={DeleteUsuario}
            onDelete={onDelete}
            itemNameKey={"nome"}
          />
        </Space>
      ),
      width: '10%',
    },
  ];

  const handlePageChange = (newPage, newRowsPerPage) => {
    setPage(newPage);
    setRowsPerPage(newRowsPerPage);
  };

  return (
    <div className="px-4">

      <div className='mt-3 mb-3'>
        <h1>Lista de Usuários Registrados</h1>
      </div>

      <ConfigProvider locale={ptBR}>
        <StyledTable
          rowKey="id"
          columns={columns}
          dataSource={state.data}
          loading={{
            spinning: loading,
            indicator: <CustomLoader />,
          }}
          pagination={{
            current: page,
            pageSize: rowsPerPage,
            total: state.totalRows,
            onChange: handlePageChange,
            showSizeChanger: true,
            onShowSizeChange: handlePageChange,
            showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`,
          }}
          scroll={{ x: "max-content", y: "20rem" }}
          locale={{
            emptyText: <h2 className="m-3">Nenhum registro disponível para exibição.</h2>,
          }}
        />
      </ConfigProvider>
    </div>
  );
};

export default GridUsuarios;
